import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
// child
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";

// validationSchema
import { Rolechema } from "../validation/roleValidation";
import useAuthToken from "../../Hooks/useAuthToken";
// api
import { apiRequest } from "../../store/api/api";

function DepartmentFrom({ data, editId, onSuccessCreated }) {
  const queryClient = useQueryClient();
  const token = useAuthToken();
  const editableID = editId?._id;
  // init
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  useEffect(() => {
    if (editId) {
      reset({
        title: editId?.title || "",
        serial: editId?.serial || 1,
      });
      setEdited(true);
    }
  }, [editId, reset]);

  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);

  const mutation = useMutation({
    mutationFn: (data) => {
      return editId
        ? apiRequest("patch", `/api/team/department/${editableID}`, data, token)
        : apiRequest("post", "/api/team/department", data, token);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["department"]);
      setLoading(false);
      toast.success("Creatred Successfuly");
      reset();
      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);

    // ✅ Form data console log
    console.log("Form Data:", formData);

    try {
      mutation.mutate({
        title: formData?.title,
        serial: formData?.serial,
      });
    } catch (error) {
      setLoading(false);
      console.error("Caught error in handleSubmit:", error.message);
      toast.error(error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} action="">
        <div className="row">
          <div className="col-sm-9">
            <div className="row">
              <div className="col-sm-4">
                <Input
                  icon="title"
                  {...register("title")}
                  error={errors.name?.message}
                  type="text"
                  placeholder={`সেন্ট্রাল বিভাগ, ফিচার বিভাগ`}
                  label="Title"
                />
              </div>
              <div className="col-sm-4">
                <Input
                  icon="title"
                  {...register("serial")}
                  error={errors.name?.message}
                  type="text"
                  placeholder={`1 or 2 or Others Number`}
                  label="Serial Number"
                />
              </div>

              <BrandButton
                type="submit"
                title={`Save Change`}
                className="my-5"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default DepartmentFrom;
